import { RHF } from "@devhop/ui";
import { DEFAULT_QUARTER_TIME } from "@/shared/lib/datetime-local-form";
import { DateQuarterTimeField } from "@/shared/ui/DateQuarterTimeField";

type FormDateQuarterTimeFieldProps = {
  name: string;
  label?: React.ReactNode;
  requiredMark?: boolean;
  disabled?: boolean;
  /** เมื่อ true ค่าว่างได้ (เช่น endDate / requestedEventDate) */
  allowEmpty?: boolean;
  /** เวลาเริ่มต้นเมื่อเลือกวันครั้งแรก (default 09:00) */
  defaultTime?: string;
  className?: string;
  hint?: React.ReactNode;
  placeholder?: string;
};

/**
 * RHF wrapper around {@link DateQuarterTimeField} (DatePicker + quarter time).
 */
export function FormDateQuarterTimeField({
  name,
  label,
  requiredMark,
  disabled,
  allowEmpty = false,
  defaultTime = DEFAULT_QUARTER_TIME,
  className,
  hint,
}: FormDateQuarterTimeFieldProps) {
  const { Controller, useFormContext } = RHF;
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <DateQuarterTimeField
          value={field.value}
          onChange={field.onChange}
          label={
            label != null ? (
              <span className="inline-flex items-center gap-1">
                {label}
                {requiredMark ? (
                  <span aria-hidden className="text-red-500">
                    *
                  </span>
                ) : null}
              </span>
            ) : undefined
          }
          disabled={disabled}
          allowEmpty={allowEmpty}
          defaultTime={defaultTime}
          className={className}
          hint={hint}
          error={fieldState.error?.message}
        />
      )}
    />
  );
}
